module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('foobar-header'), _vm._v(" "), _c('intro'), _vm._v(" "), _c('section-intro', {
    attrs: {
      "title": _vm.$t('message.title.main.privacy_and_license')
    }
  }), _vm._v(" "), _c('privacy-policies'), _vm._v(" "), _c('foobar-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-346b053a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PrivacyAndLicense.vue
// module id = 1824
// module chunks = 1